import { BFF_API_ROUTES } from 'constants/routes';

import { baseRTKApi } from 'shared/api/baseApi';

export const postDealsFastInit = baseRTKApi.injectEndpoints({
  endpoints: (build) => ({
    initDeal: build.mutation({
      query: (query) => ({
        url: BFF_API_ROUTES.initMfoDeal,
        method: 'POST',
        body: query,
      }),
      extraOptions: { maxRetries: 0 },
    }),
  }),
});
